/**
 * Formats a price value with thousand separators and no decimal places.
 * @param value - The price value (can be number or string)
 * @returns Formatted price string with commas (e.g., "1,990")
 */
export const formatPrice = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) return "0";

  const numValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numValue)) return "0";

  // Round to whole number and format with thousand separators
  return Math.round(numValue).toLocaleString("en-AU");
};
